import io from "socket.io-client";
// import { warning } from "./Notifications/notice";

export default function createSocketIoService(jokiInstance) {
    const joki = jokiInstance;
    const serviceId = "SocketIoService";

    function jokiEventHandler(event) {
        switch (event.key) {
            case "emitEvent":
                return emitEvent(event.body);
            case "initialize":
                // Currently does nothing, this could be used to actually open the socket connection in advance
                break;
            default:
                break;
        }
    }

    function emitEvent(jokiEventBody) {
        return new Promise((resolve, reject) => {
            const { url } = jokiEventBody;
            const client = io(process.env.REACT_APP_SOCKETIO_SERVER_URL);
            client.on("connect", () => {
                client.emit(url);
                client.close();
                resolve();
            });
            client.on("error", () => {
                reject();
            });
        });
    }

    joki.addService({
        id: serviceId,
        fn: jokiEventHandler,
    });
}
